/**
 * Lock- or unlock scrolling.
 */
export function lockScroll(lock, behavior = "auto") {
	if (globalThis?.window) {
		let scrollY;
		if (lock) {
			scrollY = window.scrollY ?? 0;
			document.body.style.minHeight = "100%";
			document.body.style.position = "fixed";
			document.body.style.top = scrollY ? `-${scrollY}px` : "0px";
			document.body.style.width = "100%";
		}
		else {
			scrollY = parseInt(document.body.style.top) * -1 || 0;
			document.body.style.position = "";
			document.body.style.top = "";
			document.body.style.width = "";
			document.body.style.minHeight = "";
			behavior = ["auto", "instant", "smooth"].includes(behavior) ? behavior : "auto";
			if (scrollY > 0) {
				window.scrollTo({left: 0, top: scrollY, behavior});
			}
		}
	}
}
